import { useBoolean } from "usehooks-ts";

import { serverImportSection } from "api/api-server-actions";
import { ImportSectionModal } from "components/materials/section/content/ImportSectionModal";
import { ImportSectionRequestType } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { CopySendArrowIcon } from "mds/icons";
import { toastLocalizedOperationCatcher, toastSuccessMessage } from "utils/alerts";

export const ImportSectionButton = () => {
  const { value: dialogIsShown, setTrue: showDialog, setFalse: hideDialog } = useBoolean(false);

  const handleImport = (data: ImportSectionRequestType) => {
    hideDialog();
    serverImportSection(data)
      .then(() => {
        toastSuccessMessage(t("success.toasts.import_section_started_success"));
      })
      .catch(toastLocalizedOperationCatcher("import_section_failure"));
  };

  return (
    <>
      <SquareButton
        kind="accent"
        size="s"
        title={t("content_view.import_section")}
        onClick={showDialog}
      >
        <CopySendArrowIcon />
        {t("content_view.import_section")}
      </SquareButton>
      <Dialog open={dialogIsShown} title={t("import_modal.import_section")} onClose={hideDialog}>
        <ImportSectionModal onCancel={hideDialog} onConfirm={handleImport} />
      </Dialog>
    </>
  );
};
